// import React, { useEffect, useState } from "react";
// import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { Card, FormControl, Table } from "react-bootstrap";
// import { IoIosArrowBack, IoIosArrowForward, IoMdSearch } from "react-icons/io";
// import Form from 'react-bootstrap/Form';
// import { BASE_URL } from "../../services/Api";
// import { authHeader } from "../../services/auth-header";

// const ContactTableComponets = ({ header, tableTitle, apiField, addButton, createRoute, updateRoute, viewRoute }) => {

//   console.log({ header, tableTitle, apiField, addButton, createRoute, updateRoute, viewRoute });
//   const { id, pointindex } = useParams();
//   console.log(pointindex);
//   console.log(id);
//   const count = [{ "value": 5 }, { "value": 10 }, { "value": 20 }, { "value": 50 }, { "value": 100 }, { "value": 200 }];
//   const navigate = useNavigate();
//   //useStates
//   const [projectionData, setProjectionData] = useState([]);
//   const [search, setSearch] = useState(encodeURIComponent(' '));
//   const [pages, setPages] = useState();
//   const [currentPage, setCurrentPage] = useState(pointindex.length !== 0 ? pointindex - 1 : 0);
//   const [limit, setLimit] = useState(5);
//   const [sort, setSort] = useState("desc");
//   const [currentValue, setCurrentValue] = useState("id");
//   const [totalEnteries, setTotalEnteries] = useState();
//   const [fieldnme, setfeilds] = useState("id")

  
//   async function getProjectionData() {

//     const response = await axios.get(`${BASE_URL}${apiField}/page/${id}/${currentPage}/${limit}/${sort}/${currentValue}/${search.length > 0 ? search : encodeURIComponent(' ')}`, {
//       headers: authHeader()
//     })
//       .then((response) => {
//         console.log(`${BASE_URL}projection/page/${currentPage}/${limit}/${sort}/${currentValue}/${search}`);
//         setProjectionData(response.data.Index !== undefined ? response.data.Index : response.data.data);
//         setPages(response.data.Pages);
//         setTotalEnteries(response.data.Enteries)
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//   }


//   //functions
//   function limitHandler(e) {
//     setLimit(e.target.value);
//     setCurrentPage(0);
//   }

//   function sortHandler(value) {
//     if (value.type === "svg") {
//       return;
//     }
//     setSort(sort === "asc" ? "desc" : "asc");
//     setCurrentValue(value);
//   }

//   function addButtonHandler() {
//     navigate(`${createRoute}/${id}`);
//   }


//   function handleRecentPage(i) {
//     setCurrentPage(i - 1)
//   };


//   function viewHandler(label, id) {
//     if (label === "Id") {
//       navigate(`${viewRoute}/${id}/${currentPage + 1}`)
//       return;
//     }
//     else {
//       // updateHandler(id);
//     }
//   };

//   console.log(id);

//   function pagination() {
//     const totalPages = pages;
//     const maxPagesToShow = 5; // Maximum number of page buttons to show
//     const siblingsCount = 2; // Number of sibling pages to show
//     const firstPage = 1;
//     const lastPage = totalPages;

//     let pageNumbers = [];

//     const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
//     const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

//     // Show first page button and dots if needed
//     if (startPage > firstPage + 1) {
//       pageNumbers.push(
//         <li key={firstPage} className={firstPage === currentPage + 1 ? 'newway' : 'noway'} onClick={() => handleRecentPage(firstPage)}>
//           {firstPage}
//         </li>
//       );
//       pageNumbers.push(
//         <li key="start-dots" className="dots" onClick={() => handleRecentPage(Math.max(0, startPage - siblingsCount))}>...</li>
//       );
//     } else if (startPage > firstPage) {
//       pageNumbers.push(
//         <li key={firstPage} className={firstPage === currentPage + 1 ? 'newway' : 'noway'} onClick={() => handleRecentPage(firstPage)}>
//           {firstPage}
//         </li>
//       );
//     }

//     // Collect page numbers for current range
//     for (let i = startPage; i <= endPage; i++) {
//       pageNumbers.push(
//         <li key={i} className={i === currentPage + 1 ? 'newway' : 'noway'} onClick={() => handleRecentPage(i)}>
//           {i}
//         </li>
//       );
//     }

//     // Show last page button and dots if needed
//     if (endPage < lastPage - 1) {
//       pageNumbers.push(
//         <li key="end-dots" className="dots" onClick={() => handleRecentPage(Math.min(lastPage, endPage + siblingsCount))}>...</li>
//       );
//       pageNumbers.push(
//         <li key={lastPage} className={lastPage === currentPage + 1 ? 'newway' : 'noway'} onClick={() => handleRecentPage(lastPage)}>
//           {lastPage}
//         </li>
//       );
//     } else if (endPage < lastPage) {
//       pageNumbers.push(
//         <li key={lastPage} className={lastPage === currentPage + 1 ? 'newway' : 'noway'} onClick={() => handleRecentPage(lastPage)}>
//           {lastPage}
//         </li>
//       );
//     }
//     return pageNumbers;
//   }
//   //useEffect
//   useEffect(() => {
//     getProjectionData();
//   }, []);

//   useEffect(() => {
//     getProjectionData();
//   }, [limit, sort, currentValue, search, currentPage]);

//   function previousHandler() {
//     setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
//   }

//   function nextHandler() {
//     setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
//   }

//   console.log(projectionData)
//   return (
//     <Card>

//       <div className="card-header">
//         <h6>{tableTitle}</h6>

//         <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>

//           <button
//             onClick={() => navigate(-1)}
//             className="button-70"
//           >
//             🔙 Back
//           </button>
//           {addButton && (
//             <button onClick={addButtonHandler} className="button-70">
//               <span className="add-cratebutton">{addButton}</span>
//             </button>
//           )}
//         </div>
//       </div>

//       <Card.Body>
//         <div className="entryandsearch">
//           <div className="bottole">
//             <p>Show entries</p>
//             <Form.Select className="indexselect" onChange={(e) => limitHandler(e)}>
//               {count.map((item) => (
//                 <option>{item.value}</option>
//               ))}
//             </Form.Select>
//           </div>
//           <div className="search ">
//             <FormControl
//               className=" index searchBar searchindex"
//               type="text"
//               placeholder='Search . . .'
//               onChange={(e) => {
//                 setSearch(e.target.value);
//               }}
//             />
//           </div>
//         </div>

//         <Table responsive className="custom-table">
//           <thead>

//             <tr>
//               {header.map((head) => (
//                 <th onClick={() => sortHandler(head.field)}>{head.label} {head.label !== "Action" ? sort === "asc" ? <TiArrowSortedDown /> : <TiArrowSortedUp /> : ""}</th>
//               ))}
//             </tr>
//           </thead>

//           <tbody className="the">
//             {
//               projectionData &&
//               projectionData.map((data) => (
//                 <tr key={data.id}>
//                   {header.map((head) => (
//                     <td
//                       onClick={() => viewHandler(head.label, data.id)}
//                       className={head.label === "Id" ? "id-column" : ""}
//                     >
//                       {data[head.field]}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             }
//           </tbody>
//         </Table>
//         <div className="projection-table-pagination">
//           <p>Showing 1 to {projectionData?.length} of {currentPage + 1} Page</p>
//           <div className="prev-next-div">
//             <button className="noway-2" onClick={previousHandler} style={{ cursor: "pointer" }}><IoIosArrowBack style={{ fontSize: "20px" }} /></button>
//             <div style={{ display: "flex", gap: "10px" }}>
//               {
//                 pagination()
//               }
//             </div>
//             <button className="noway-2" onClick={nextHandler} style={{ cursor: "pointer" }}><IoIosArrowForward style={{ fontSize: "20px" }} /></button>
//           </div>
//         </div>
//       </Card.Body>
//     </Card>
//   )
// }

// export default ContactTableComponets;


import React, { useEffect, useState } from "react";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";
import Swal from "sweetalert2";
import "../Brand/BrandComponents.css"; 

const ContactTableComponents = ({ 
    header, 
    tableTitle, 
    apiField, 
    addButton, 
    createRoute, 
    updateRoute, 
    viewRoute 
}) => {
    const { id, pointindex } = useParams();
    const navigate = useNavigate();

    const count = [{ value: 5 }, { value: 10 }, { value: 20 }, { value: 50 }, { value: 100 }, { value: 200 }];

    // States
    const [projectionData, setProjectionData] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [search, setSearch] = useState(encodeURIComponent(' '));
    const [pages, setPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(pointindex ? pointindex - 1 : 0);
    const [limit, setLimit] = useState(5);
    const [sort, setSort] = useState("desc");
    const [currentValue, setCurrentValue] = useState("id");
    const [totalEnteries, setTotalEnteries] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    // Debounced search
    useEffect(() => {
        const timer = setTimeout(() => {
            setSearch(encodeURIComponent(searchInput.trim() || " "));
            setCurrentPage(0);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchInput]);

    // Fetch data
    async function getProjectionData() {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `${BASE_URL}${apiField}/page/${id}/${currentPage}/${limit}/${sort}/${currentValue}/${search}`,
                { headers: authHeader() }
            );
            setProjectionData(response.data.Index !== undefined ? response.data.Index : response.data.data);
            setPages(response.data.Pages);
            setTotalEnteries(response.data.Enteries);
        } catch (error) {
            console.error("Error fetching data:", error);
            Swal.fire({
                title: 'Error!',
                text: 'Failed to fetch data',
                icon: 'error'
            });
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getProjectionData();
    }, [limit, sort, currentValue, search, currentPage]);

    // Handlers
    function limitHandler(e) {
        setLimit(parseInt(e.target.value));
        setCurrentPage(0);
    }

    function sortHandler(value) {
        setSort(sort === "asc" ? "desc" : "asc");
        setCurrentValue(value);
    }

    function addButtonHandler() {
        navigate(`${createRoute}/${id}`);
    }

    function updateHandler(dataId) {
        navigate(`${updateRoute}/${dataId}/${currentPage + 1}`);
    }

    async function deleteHandler(dataId) {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await axios.delete(
                    `${BASE_URL}${apiField}/delete/${dataId}`,
                    { headers: authHeader() }
                );
                
                await Swal.fire({
                    title: 'Deleted!',
                    text: response.data.message || 'Item deleted successfully',
                    icon: 'success'
                });
                getProjectionData(); // Refresh data
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text: error.response?.data?.message || 'Failed to delete item',
                    icon: 'error'
                });
            }
        }
    }

    function handleRecentPage(i) {
        setCurrentPage(i - 1);
    }

    function viewHandler(label, dataId) {
        if (label === "Id" && viewRoute) {
            navigate(`${viewRoute}/${dataId}/${currentPage + 1}`);
        }
    }

    function previousHandler() {
        setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
    }

    function nextHandler() {
        setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
    }

    // Pagination render
    function renderPagination() {
        const totalPages = pages;
        const siblingsCount = 2;
        const firstPage = 1;
        const lastPage = totalPages;
        let pageNumbers = [];

        const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
        const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

        if (startPage > firstPage + 1) {
            pageNumbers.push(
                <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
                    {firstPage}
                </button>
            );
            pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`bc-page-btn${i === currentPage + 1 ? ' bc-page-btn--active' : ''}`}
                    onClick={() => handleRecentPage(i)}
                >
                    {i}
                </button>
            );
        }

        if (endPage < lastPage - 1) {
            pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
            pageNumbers.push(
                <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
                    {lastPage}
                </button>
            );
        }

        return pageNumbers;
    }

    return (
        <div className="bc-card">
            {/* Header */}
            <div className="bc-card__header">
                <h6 className="bc-card__title">{tableTitle}</h6>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <button
                        onClick={() => navigate(-1)}
                        className="bc-add-btn"
                        style={{ background: "linear-gradient(135deg, #6c757d, #5a6268)" }}
                    >
                        🔙 Back
                    </button>
                    {addButton && (
                        <button onClick={addButtonHandler} className="bc-add-btn">
                            {addButton}
                        </button>
                    )}
                </div>
            </div>

            {/* Body */}
            <div className="bc-card__body">
                {/* Controls */}
                <div className="bc-controls">
                    <div className="bc-entries">
                        <span className="bc-entries__label">Show entries:</span>
                        <select className="bc-entries__select" onChange={limitHandler} value={limit}>
                            {count.map((item) => (
                                <option key={item.value} value={item.value}>{item.value}</option>
                            ))}
                        </select>
                    </div>

                    <input
                        className="bc-search"
                        type="text"
                        placeholder="Search..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                    />
                </div>

                {/* Table */}
                <div className="bc-table-wrapper">
                    <table className="bc-table">
                        <thead>
                            <tr>
                                {header.map((head) => (
                                    <th
                                        key={head.field}
                                        className={`bc-th bc-th--sortable${currentValue === head.field ? ' bc-th--active' : ''}`}
                                        onClick={() => head.label !== "Action" && sortHandler(head.field)}
                                        style={{ cursor: head.label !== "Action" ? "pointer" : "default" }}
                                    >
                                        {head.label}
                                        {head.label !== "Action" && currentValue === head.field && (
                                            <span className="bc-sort-icon">
                                                {sort === 'asc' ? ' ↑' : ' ↓'}
                                            </span>
                                        )}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={header.length} className="bc-td bc-td--empty">
                                        Loading...
                                    </td>
                                </tr>
                            ) : projectionData?.length > 0 ? (
                                projectionData.map((data) => (
                                    <tr key={data.id} className="bc-tr">
                                        {header.map((head) => (
                                            <td key={head.field} className="bc-td">
                                                {head.label === "Action" ? (
                                                    <div className="bc-actions">
                                                        <button
                                                            className="bc-action-btn bc-action-btn--view"
                                                            onClick={() => viewHandler("Id", data.id)}
                                                            title="View"
                                                        >
                                                            👁️
                                                        </button>
                                                        <button
                                                            className="bc-action-btn bc-action-btn--edit"
                                                            onClick={() => updateHandler(data.id)}
                                                            title="Edit"
                                                        >
                                                            ✏️
                                                        </button>
                                                        <button
                                                            className="bc-action-btn bc-action-btn--delete"
                                                            onClick={() => deleteHandler(data.id)}
                                                            title="Delete"
                                                        >
                                                            🗑️
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <span
                                                        className={`bc-cell-text${head.label === "Id" ? ' bc-cell-text--id' : ''}`}
                                                        onClick={() => viewHandler(head.label, data.id)}
                                                    >
                                                        {data[head.field]}
                                                    </span>
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={header.length} className="bc-td bc-td--empty">
                                        No data found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="bc-pagination">
                    <span className="bc-pagination__info">
                        Showing {projectionData?.length || 0} of {totalEnteries} entries
                    </span>

                    <div className="bc-pagination__controls">
                        <button
                            className={`bc-nav-btn${currentPage === 0 ? ' bc-nav-btn--disabled' : ''}`}
                            onClick={previousHandler}
                            disabled={currentPage === 0}
                            title="Previous"
                        >
                            <IoIosArrowBack />
                        </button>

                        <div className="bc-pages">
                            {renderPagination()}
                        </div>

                        <button
                            className={`bc-nav-btn${currentPage >= pages - 1 ? ' bc-nav-btn--disabled' : ''}`}
                            onClick={nextHandler}
                            disabled={currentPage >= pages - 1}
                            title="Next"
                        >
                            <IoIosArrowForward />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactTableComponents;